import cn from 'bem-cn';

import { ScreenSize, useGetScreenSize } from '../../../../../hooks';
import { Stack } from '../../../../UI';

import { ChallengePrizeProps } from './ChallengePrize.types';
import './ChallengePrize.scss';

const b = cn('challenge-prize');

export const ChallengePrize = (props: ChallengePrizeProps) => {
    const { prize, last } = props;
    const { title, image, text } = prize;

    const screenSize = useGetScreenSize();
    const isTouch = screenSize === ScreenSize.Mobile || screenSize === ScreenSize.Tablet;

    if (last) {
        return (
            <Stack className={b({ last: true, touch: isTouch })} justifyContent="space-between">
                <Stack spacing={12}>
                    <h3 className={b('title')}>{title}</h3>
                    <p>{text}</p>
                </Stack>
                <img className={b('image')} src={image} alt="" />
            </Stack>
        );
    }

    return (
        <Stack className={b()} justifyContent="space-between">
            <h3 className={b('title')}>{title}</h3>
            <img className={b('image')} src={image} alt="" />
            <p>{text}</p>
        </Stack>
    );
};
